import { I18n } from "@ies/starling_intl";
/// <reference types="styled-components/cssprop" />
import React, { Suspense, useEffect, useMemo, useRef, useState } from "react";
import {
  Switch,
  useLocation,
  useHistory,
  Redirect,
  useRouteMatch,
} from "react-router-dom";
import styled from "styled-components";
import { Layout } from "@arco-design/web-react";
import { message, Spin } from "antd";
import watermark from "ssa_watermark";
import { createApp } from "@reduck/core";
import immer from "@reduck/plugin-immer";
import { useCommonModel } from "@/models";
import { api, setBrowserHistory } from "@/apis/axios";
import { AppHeader } from "./components/AppHeader";
import { getRoutes, routesNoNeedLogin } from "./common/router";
import SiderMenu from "./components/siderMenu";
import Inspector from "./Inspector";
import { UserInfo } from "./models/common";
import { QualityOnlyverifyPermission } from "./apis";

const Index: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const [{ userInfo, projectInfo }, { init, setProjectInfo }] =
    useCommonModel();
  const watermarkRef = useRef<any>();
  const [isNeedLogin, setIsNeedLogin] = useState(false);
  const [auditionAuth, setAuditionAuth] = useState(false);
  const match = useRouteMatch("/:projectID");
  const { pathname } = useLocation();
  const projectID = useMemo(() => {
    if (match === null) {
      return 0;
    } else if ((match.params as any).projectID !== undefined) {
      try {
        return Number((match.params as any).projectID);
      } catch {
        return 0;
      }
    } else {
      return 0;
    }
  }, [pathname]);

  /** 判断当前的用户有没有提审包上传的权限 */
  const checkPermission = async () => {
    QualityOnlyverifyPermission(
      "right_bpo_tester_operator",
      projectID,
      true,
    ).then(res => {
      setAuditionAuth(res);
    });
  };

  /**获取当前的项目信息然后set公共值*/
  const getProjectInfo = async (id: number) => {
    try {
      await api.get(`/v1/projects/detail/${id}`, {}).then(res => {
        setProjectInfo(res);
      });
    } catch (error) {
      if (error?.code === 1000) {
        history.push("/my-project");
      }
    }
  };

  useEffect(() => {
    // console.log(location, 1, projectInfo, projectID);\
    // projectID!==projectInfo?.id
    // console.log(projectID, "projectID----");
    if (projectID) {
      getProjectInfo(projectID);
      // console.log(projectID,projectInfo,2)
      checkPermission();
    }
  }, [projectID]);

  const userType = useMemo(() => {
    if ((userInfo as UserInfo).id === 0) {
      return "unknown";
    }
    if (userInfo.isBpo) {
      return auditionAuth ? "project_bpo_tester" : "bpo";
    } else if (!userInfo.isInternal) {
      return "external";
    } else {
      return "internal";
    }
  }, [userInfo, auditionAuth]);
  /** 安全s MSSDK */
  useEffect(() => {
    if ((window as any).byted_acrawler) {
      // console.log('----MSSDK LOADED');
      (window as any).byted_acrawler.init({
        aid: 2775,
        isSDK: true,
        region: "cn",
        boe: false,
        enablePathList: [
          // '.*',
          "https://shortlink.zijieapi.com/web_shorten/*",
          // 'd{1,}/testManagement/wrapManage',
          // 'd{1,}/hold-all/re-sign-package',
        ],
      });
    }
  }, []);

  const routers = getRoutes(userType);
  // TEA 埋点配置
  useEffect(() => {
    if (userInfo.id) {
      (window as any).Tea("config", {
        user_unique_id: userInfo.username,
        evtParams: { username: userInfo.username, email: userInfo.email },
      });
      (window as any).Tea("start");
    }
  }, [userInfo]);
  // TEA 页面埋点上报
  useEffect(() => {
    (window as any).Tea("predefinePageView");
  }, [location]);

  useEffect(() => {
    setBrowserHistory(history);
  }, [history]);

  useEffect(() => {
    // 除了部分路径可以在非登录情况下使用，其他路由都需要在登录后才能使用
    if (
      !userInfo.id &&
      !routesNoNeedLogin.some(r => location.pathname.startsWith(r))
    ) {
      init().then(({ value }) => {
        const user = value.userInfo;
        watermarkRef.current?.destroy?.();

        const result = watermark({
          containerDom: document.body,
          text: `${user.nickname}  ${user.id}`,
          fontSize: 14,
          opacity: 0.1,
          color: "#a1a4a9",
          width: 250,
          rotateDegree: -20,
          zIndex: 11,
          onChange: () => {
            message.warning(
              I18n.t(
                "do_not_modify_the_watermark__your_operation_has_been_recorded",
                {},
                "请勿修改水印，你的操作已被记录",
              ),
            );
          },
        });

        watermarkRef.current = result;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const rootRoutes = [
    "/download",
    "/my-project",
    "/new-project",
    "/qa-weekly",
    "/work-order",
    "/certs-management",
    "/project-progress",
    "/external-scan",
    "/external-flow-scan",
    "/external-google-scan",
    "/external-googleFlow-scan",
    "/personal-information",
    "/privilegeManagement/addPrivilegeManagement",
    "/appStoreUserManagement/list",
    "/googlePlayUserManagement/list",
    "/allqareviewing/list",
    "/onlinestatus/list",
    "/role-permissions-apply",
    "/redirect",
    "/goto/appStoreReviewTicketDetail",
    "/goto/qaTestDetail",
    "/bTest/releaseTesting/surveyNote/surveyNoteDetails",
    "/bTest/appStoreReview/tickets/details",
    "/goto/googlePlay/detail",
    "/login",
    "/signout",
    "review/google",
    "review/apple",
    "/online-quality",
    "/issues",
    "/online-market",
    "/execute-usecase",
    "/noPermission/download",
    "/bpo-overview",
    "/bpo-data-entry",
    // '/terms',
  ];
  useEffect(() => {
    const flag =
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.exec(
        navigator.userAgent,
      );
    if (
      ![
        "/login",
        "/signout",
        "/",
        "/terms",
        "/privacy-policy",
        "/apply-mail",
        "/download",
      ].includes(window.location.pathname) &&
      !window.location.pathname.includes("/noPermission/download")
    ) {
      setIsNeedLogin(true);
      if (
        !(window.location.pathname.search("/role-permissions-apply") !== -1) &&
        !(window.location.pathname.search("/share") !== -1) &&
        !(window.location.pathname.search("/summary") !== -1)
      ) {
        localStorage.setItem(
          "redirect_path",
          window.location.pathname + window.location.search,
        );
      }
    } else {
      setIsNeedLogin(!flag);
    }
    if (window.location.pathname === "/helpFile") {
      window.location.href =
        "https://bytedance.feishu.cn/docs/doccnfrU2MYh7VyH07JxgvHw3Xd#";
    }
  }, [window.location.pathname]);
  // React 代码使用新路径，其他路径都交给老的 Vue 代码去处理
  if (
    !/\/\d+\//.test(location.pathname) &&
    !rootRoutes.some(item => location.pathname.includes(item))
  ) {
    return <Redirect to="/my-project" />;
  }
  if (location.pathname.includes("/project/")) {
    return null;
  }

  return (
    <Inspector>
      <Wrapper
        style={{
          minWidth: isNeedLogin ? "1400px" : "initial",
        }}>
        <AppHeader />
        <Layout
          style={{
            minHeight: "calc(100vh - 45px)",
            flexDirection: "initial",
          }}>
          {<SiderMenu />}
          <Layout.Content
            style={{
              width: "100vh",
              overflow: "auto",
            }}>
            <Suspense
              fallback={
                <div
                  style={{
                    width: "100%",
                    height: "100vh",
                    background: "rgba(0, 0, 0, 0.05)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}>
                  <Spin size="large" />
                </div>
              }>
              <Switch>{routers}</Switch>
            </Suspense>
          </Layout.Content>
        </Layout>
      </Wrapper>
    </Inspector>
  );
};

const Wrapper = styled.div`
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .arco-layout-sider {
    box-shadow: rgba(0, 2, 4, 0.15) 2px 0px 6px !important;
    z-index: 1000;
  }
  .arco-layout-content {
    /* overflow-x: auto !important; */
  }
  .footerFoldIcon {
    position: absolute;
    right: -8px;
    font-size: 18px;
    color: #1890ff;
    cursor: pointer;
    z-index: 1000;
    top: 50px;
  }
  /* .ant-layout-sider-collapsed {
    width: 90px !important;
    flex: 0 0 90px !important;
    max-width: 90px !important;
    min-width: 90px !important;
  } */
`;

export const App = createApp({ plugins: [immer], disableLogger: true })(Index);

export default App;
